import { ApiResult, HttpClient } from "../http.js";
import {
  CustomReportDto,
  CustomReportFormula,
  LostQuoteAnalyticsDto,
} from "../types/custom-reports.js";

export interface CreateCustomReportPayload {
  name: string;
  description?: string | null;
  dataSource: string;
  reportType?: string | null;
  metric: string;
  operation: string;
  visualization: string;
  groupBy: string;
  formula?: CustomReportFormula | null;
  year?: number | null;
  id?: string;
}

/**
 * Partial update. Omit a key to leave it unchanged. Send `formula: null` explicitly
 * to clear the formula — the API distinguishes an omitted key from an explicit null.
 */
export interface UpdateCustomReportPayload {
  name?: string;
  description?: string | null;
  dataSource?: string;
  reportType?: string | null;
  metric?: string;
  operation?: string;
  visualization?: string;
  groupBy?: string;
  formula?: CustomReportFormula | null;
  year?: number | null;
  order?: number;
  isActive?: boolean;
}

export class CustomReportsApi {
  constructor(private readonly http: HttpClient) {}

  list(): Promise<ApiResult<CustomReportDto[]>> {
    return this.http.get<CustomReportDto[]>("/api/custom-reports");
  }

  get(id: string): Promise<ApiResult<CustomReportDto>> {
    return this.http.get<CustomReportDto>(`/api/custom-reports/${encodeURIComponent(id)}`);
  }

  create(payload: CreateCustomReportPayload): Promise<ApiResult<string>> {
    return this.http.post<string>("/api/custom-reports", { body: payload });
  }

  update(id: string, payload: UpdateCustomReportPayload): Promise<ApiResult<CustomReportDto>> {
    return this.http.put<CustomReportDto>(`/api/custom-reports/${encodeURIComponent(id)}`, { body: payload });
  }

  remove(id: string): Promise<ApiResult<void>> {
    return this.http.delete<void>(`/api/custom-reports/${encodeURIComponent(id)}`);
  }

  /** Server-computed lost/rejected-quote time-entry analytics for the active org. */
  lostQuoteAnalytics(): Promise<ApiResult<LostQuoteAnalyticsDto>> {
    return this.http.get<LostQuoteAnalyticsDto>("/api/custom-reports/lost-quote-analytics");
  }
}
